import axios from 'axios';

export const sendHttpRequest = async (baseUrl: string, endpoint: string, method: string, params: any = {}) => {
    const url = `${baseUrl}${endpoint}`;
    const response = await axios({
        url,
        method,
        params,
    });

    return response.data;
};